import axios from 'axios';

const service = axios.create({
  timeout: 15000, // request timeout
});

export default service;
